import modernizr from "./modernizr.js";
import { Tooltip, Toast, Popover } from 'bootstrap';
import counterUp from 'counterup2';
import Lenis from 'lenis';
import gsap from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';


/*
 *   Define document height for mobile devices
 */

const documentHeight = () => {
	const doc = document.documentElement
	doc.style.setProperty('--doc-height', `${window.innerHeight}px`)
}
window.addEventListener('resize', documentHeight)
documentHeight();


/*
 *   Wavify
 *   JavaScript library to make some nice waves
 *   by peacepostman @ potion
 *      gsap 3.8.0 update by tonycre8
 */

function wavify(wave_element, options) {
	if ("undefined" === typeof options) options = {};

  //  Options
  //
  //
	var settings = Object.assign({}, {
		container: options.container ? options.container : "body",
          // Height of wave
		height: 200,
          // Amplitude of wave
		amplitude: 100,
          // Animation speed
		speed: 0.15,
          // Total number of articulation in wave
		bones: 3,
          // Color
		color: "rgba(255,255,255, 0.20)"
	},
	options
	);

	var wave = wave_element,
	width = document.querySelector(settings.container).getBoundingClientRect()
	.width,
	height = document.querySelector(settings.container).getBoundingClientRect()
	.height,
	points = [],
	lastUpdate,
	totalTime = 0,
	animationInstance = false,
	gsapInstance = false;

  //  Allow new settings, avoid setting new container for logic purpose please :)
  //
	function rebuildSettings(params) {
		settings = Object.assign({}, settings, params);
	}

	function drawPoints(factor) {
		var points = [];

		for (var i = 0; i <= settings.bones; i++) {
			var x = (i / settings.bones) * width;
			var sinSeed =
			(factor + (i + (i % settings.bones))) * settings.speed * 100;
			var sinHeight = Math.sin(sinSeed / 100) * settings.amplitude;
			var yPos = Math.sin(sinSeed / 100) * sinHeight + settings.height;
			points.push({
				x: x,
				y: yPos
			});
		}

		return points;
	}

	function drawPath(points) {
		var SVGString = "M " + points[0].x + " " + points[0].y;

		var cp0 = {
			x: (points[1].x - points[0].x) / 2,
			y: points[1].y + (points[1].y - points[0].y)
		};

		SVGString +=
		" C " +
		cp0.x +
		" " +
		cp0.y +
		" " +
		cp0.x +
		" " +
		cp0.y +
		" " +
		points[1].x +
		" " +
		points[1].y;

		var prevCp = cp0;
		var inverted = -1;

		for (var i = 1; i < points.length - 1; i++) {
			var cpLength = Math.sqrt(prevCp.x * prevCp.x + prevCp.y * prevCp.y);
			var cp1 = {
				x: points[i].x - prevCp.x + points[i].x,
				y: points[i].y - prevCp.y + points[i].y
			};

			SVGString +=
			" C " +
			cp1.x +
			" " +
			cp1.y +
			" " +
			cp1.x +
			" " +
			cp1.y +
			" " +
			points[i + 1].x +
			" " +
			points[i + 1].y;
			prevCp = cp1;
			inverted = -inverted;
		}

		SVGString += " L " + width + " " + height;
		SVGString += " L 0 " + height + " Z";
		return SVGString;
	}

  //  Draw function
  //
  //
	function draw() {
		var now = window.Date.now();

		if (lastUpdate) {
			var elapsed = (now - lastUpdate) / 1000;
			lastUpdate = now;

			totalTime += elapsed;

			var factor = totalTime * Math.PI;
			gsapInstance = gsap.to(wave, settings.speed, {
				attr: {
					d: drawPath(drawPoints(factor))
				},
				ease: "sine.inOut",
			});
			gsapInstance.progress(1);
          // Fixes width on resize.
		} else {
			lastUpdate = now;
		}

		animationInstance = requestAnimationFrame(draw);
	}

  //  Pure js debounce function to optimize resize method
  //
  //
	function debounce(func, wait, immediate) {
		var timeout;
		return function () {
			var context = this,
			args = arguments;
			clearTimeout(timeout);
			timeout = setTimeout(function () {
				timeout = null;
				if (!immediate) func.apply(context, args);
			}, wait);
			if (immediate && !timeout) func.apply(context, args);
		};
	}

  //  Redraw for resize with debounce
  //
	var redraw = debounce(function () {
		pause();
		points = [];
		totalTime = 0;
		width = document.querySelector(settings.container).getBoundingClientRect()
		.width;
		height = document.querySelector(settings.container).getBoundingClientRect()
		.height;
		lastUpdate = false;
		console.log(width)
		play();
	}, 0);

	function boot() {
		if (!animationInstance) {
			gsapInstance = gsap.set(wave, {
				attr: {
					fill: settings.color
				}
			});
			play();
			window.addEventListener("resize", redraw);
		}
	}

	function reboot(options) {
		kill();
		if (typeof options !== undefined) {
			rebuildSettings(options);
		}
		gsapInstance = gsap.set(wave, {
			attr: {
				fill: settings.color
			}
		});
		play();
		window.addEventListener("resize", redraw);
	}

	function play() {
		if (!animationInstance) {
			animationInstance = requestAnimationFrame(draw);
		}
	}

	function pause() {
		if (animationInstance) {
			cancelAnimationFrame(animationInstance);
			animationInstance = false;
		}
	}

	function updateColor(options) {
		if (typeof options.timing === undefined) {
			options.timing = 1;
		}
		if (typeof options.color === undefined) {
			options.color = settings.color;
		}
		gsapInstance = gsap.to(wave, parseInt(options.timing), {
			attr: {
				fill: options.color
			},
			onComplete: function () {
				if (
					typeof options.onComplete !== undefined && {}.toString.call(options.onComplete) === "[object Function]"
					) {
					options.onComplete();
			}
		}
	});
	}

	function kill() {
		if (animationInstance) {
			pause();
			gsapInstance.kill();
			gsapInstance = gsap.set(wave, {
				x: 0,
				y: 0,
				rotation: 0,
				opacity: 0,
				clearProps: "all",
				attr: {
					d: "M0,0",
					fill: ""
				}
			});
			window.removeEventListener("resize", redraw);
			animationInstance = false;
		}
	}

  //  Boot Wavify
  //
	boot();

	return {
		reboot: reboot,
		play: play,
		pause: pause,
		kill: kill,
		updateColor: updateColor
	};
}


/*
 *   Wavify
 *   Jquery Plugin to make some nice waves
 *   by peacepostman @ potion
 */

(function($) {
	$.fn.wavify = function(options) {
		if ("function" !== typeof wavify) {
			console.error(
				"wavify is not a function. Be sure to include 'wavify.js' before you include 'jquery.wavify.js'."
				);
			throw "Error: wavify is not a function";
		}

		return wavify(this, options);
	};
})(jQuery);


/*
 *   Header
 */

(function($) {

	var $window = $(window),
	$document = $(document),
	$body = $('body'),
	$header,
	$alert,
	scrollTop = 0,
	logScrollTop = 0,
	headerHeight = 0,
	adminBarHeight = 0,
	alertHeight = 0,
	$wpadminbar = null,
	alertRemoved = false,
	$scrollSections, 
	$scrollLinks,
	activeSection,
	isScrolling,
	$arrowElem;

	function responding() {
		if ( $header.length ) {
			headerHeight = $header.height();
		}

		if ( $wpadminbar.length ) {
			adminBarHeight = $wpadminbar.height();

			headerHeight = headerHeight + adminBarHeight;
		}

		if ( $alert.length && ! alertRemoved ) {
			alertHeight = $alert.height();
			headerHeight = headerHeight + alertHeight;
		}

		scrolling();
	}

	function resizing() {
		if ( $wpadminbar.length ) {
			adminBarHeight = $wpadminbar.height();

			headerHeight = headerHeight + adminBarHeight;
		}
	}

	function clearScroll() {
		$("html, body").stop();
	}

	function scrollToPos(pos) {
		var extra = 100;
		$("html, body").animate({ scrollTop: pos - extra });
		$(window).one("mousedown DOMMouseScroll mousewheel keyup", clearScroll);
	}

	function scrollToElement(href) {
		var $el = $(href);

		if (!$el.length) {
			$el = $("[name="+href.substring(1)+"]");
		}

		if ($el.length) {
			var pos = $el.offset(),
			offset = 20;

			if (href === "#top") {
				pos.top = 0;
			}

			scrollToPos(pos.top - offset);
		}
	}

	function scrollTo(e) {
		var $target = $(e.currentTarget),
		href = $target.attr("href");

		if (href !== "#") {
			e.stopPropagation();
			e.preventDefault();
			scrollToElement(href);
		} else {
			scrollToPos(0);
		}
	}

	function scrolling() {
		scrollTop =  $window.scrollTop();

		if ( scrollTop > headerHeight ) {
			$body.addClass('scrolling');

				if ( scrollTop >= logScrollTop ) { // scrolling down
					if ( parseInt($header.css('top')) > '-' + headerHeight ) {
						$header.stop().css('top', '-' + headerHeight + 'px' );
					}

				} else { // scrolling up
					if ( parseInt($header.css('top')) < 0 ) {
						$header.css('top', '-' + headerHeight + 'px' )
						.animate({
							top: adminBarHeight
						}, 200);
					}
				}

				if ( ! isScrolling ) {
					isScrolling = true;
				}
			} else {
				if ( isScrolling ) {
					$body.removeClass('scrolling');
					resetHeight = 0;
					$header.stop().css('top', 0);
				}

				isScrolling = false;
			}

			logScrollTop = scrollTop;
		}

		function init() {
			$header = $('.header');
			$wpadminbar = $('#wpadminbar');
			$alert = $('.js-alert');

			$('.js-alert-close').on('click', function () {
				$alert.remove();
				alertHeight = 0;
				alertRemoved = true;

				responding();
			});

		// $('.js-scrollTo a').on('click', scrollTo);

			$window.on("mqchange.mediaquery", responding)
			.on("resize", resizing)
			.on("scroll", scrolling);

			responding();
		}

	// init();// 

	})(jQuery);


/*
 *   Navigation
 */

(function($) {

	var $body = $('body'),
	$videoContainer,
	$mainNavigation,
	$mainNavigationItems,
	$mainNavigationHandle,
	mainNavigationVisible = false,
	$search,
	$searchHandle,
	searchVisible = false;

	// jQuery formatted selector to search for focusable items
	var focusableElementsString = "a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]";

	// store the item that has focus before opening the modal window
	var focusedElementBeforeModal;

	function insertBackgroundVideo(videoURL, $videoContainer) {
		var $videoWrapper = '<iframe src="//' + videoURL + '?background=1&wmode=transparent" width="100%" height="100%" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>';
		$videoContainer.html( $videoWrapper );
	}

	function selectBackgroundVideo($videoContainer) {
		insertBackgroundVideo($videoContainer.data('video-desktop'), $videoContainer);
	}

	function hoverOn(e) {
		$body.addClass('hover');
		$(this).addClass('hover');
	}

	function hoverOff(e) {
		$body.removeClass('hover');
		$(this).removeClass('hover');
	}

	function focusOn(e) {
		$body.addClass('hover');
		$(this).parent().addClass('focus');
	}

	function focusOff(e) {
		$body.removeClass('hover');
		$(this).parent().removeClass('focus');
	}

	function trapEscapeKey(obj, evt) {

	    // if escape pressed
		if (evt.which == 27) {

	        // get list of all children elements in given object
			var o = obj.find('*');

	        // get list of focusable items
			var cancelElement;
			cancelElement = o.filter("#cancel");

	        // close the modal window
			cancelElement.click();
			evt.preventDefault();
		}

	}

	function trapTabKey(obj, evt) {

	    // if tab or shift-tab pressed
		if (evt.which == 9) {

	        // get list of all children elements in given object
			var o = obj.find('*');

	        // get list of focusable items
			var focusableItems;
			focusableItems = o.filter(focusableElementsString).filter(':visible');

	        // get currently focused item
			var focusedItem;
			focusedItem = $(':focus');

	        // get the number of focusable items
			var numberOfFocusableItems;
			numberOfFocusableItems = focusableItems.length;

	        // get the index of the currently focused item
			var focusedItemIndex;
			focusedItemIndex = focusableItems.index(focusedItem);

			if (evt.shiftKey) {
	            //back tab
	            // if focused on first item and user preses back-tab, go to the last focusable item
				if (focusedItemIndex == 0) {
					focusableItems.get(numberOfFocusableItems - 1).focus();
					evt.preventDefault();
				}

			} else {
	            //forward tab
	            // if focused on the last item and user preses tab, go to the first focusable item
				if (focusedItemIndex == numberOfFocusableItems - 1) {
					focusableItems.get(0).focus();
					evt.preventDefault();
				}
			}
		}

	}

	function setInitialFocusModal(obj) {
	    // get list of all children elements in given object
		var o = obj.find('*');

	    // set focus to first focusable item
		var focusableItems;
		focusableItems = o.filter(focusableElementsString).filter(':visible').first().focus();

	}

	function enterButtonModal() {
	    // BEGIN logic for executing the Enter button action for the modal window
		alert('form submitted');
	    // END logic for executing the Enter button action for the modal window
		hideModal();
	}

	function setFocusToFirstItemInModal(obj){
	    // get list of all children elements in given object
		var o = obj.find('*');

	    // set the focus to the first keyboard focusable item
		o.filter(focusableElementsString).filter(':visible').first().focus();
	}

	function toggleSearch(e) {
		e.preventDefault();

		if ( searchVisible ) {
			$searchHandle.removeClass('is-active').text('Menu');
			$search.removeClass('is-active').attr('aria-hidden', 'true');
			searchVisible = false;

			$body.removeClass('fs-navigation-lock')
			.off('focusin','#page');

			$('#page').attr('aria-hidden', 'false');

			focusedElementBeforeModal.focus();
		} else {
			$searchHandle.addClass('is-active').text('Close');
			$search.addClass('is-active').attr('aria-hidden', 'false');
			searchVisible = true;

			$body.addClass('fs-navigation-lock')
			.on('focusin','#page',function() {
				setFocusToFirstItemInModal($search);
			});

			$('#page').attr('aria-hidden', 'true');

			focusedElementBeforeModal = $(':focus');

			setFocusToFirstItemInModal($search);
		}
	}

	function toggleMobileMenu(e) {
		e.preventDefault();

		if ( mainNavigationVisible ) {
			$mainNavigationHandle.removeClass('is-active').find('.visually-hidden').text('Menu');
			$mainNavigation.removeClass('is-active').attr('aria-hidden', 'true');
			mainNavigationVisible = false;

			$body.removeClass('fs-navigation-lock').removeClass('menu-open')
			.off('focusin','#page');

			$('#page').attr('aria-hidden', 'false');

			focusedElementBeforeModal.focus();

			$('.js-menu-video').empty();

		} else {
			$mainNavigationHandle.addClass('is-active').find('.visually-hidden').text('Close');
			$mainNavigation.addClass('is-active').attr('aria-hidden', 'false');
			mainNavigationVisible = true;

			$body.addClass('fs-navigation-lock').addClass('menu-open')
			.on('focusin','#page',function() {
				setFocusToFirstItemInModal($mainNavigation);
			});

			$('#page').attr('aria-hidden', 'true');

			focusedElementBeforeModal = $(':focus');

			setFocusToFirstItemInModal($mainNavigation);

			$videoContainer = $('.js-menu-video');

			if ( $videoContainer.length ) {
				selectBackgroundVideo($videoContainer);
			}
		}
	}

	function init() {
		$mainNavigation = $('.js-navigation');

		$mainNavigationItems = $mainNavigation.find('.menu-item')
		.on('mouseover', hoverOn)
		.on('mouseout', hoverOff);

		$mainNavigationItems.find('a')
		.on('focus', focusOn)
		.on('blur', focusOff);

		$mainNavigationHandle = $('.js-navigation-handle')
		.on('click touchstart', toggleMobileMenu);

		$('.js-menu-item-expand').on('click', function(e) {
			var $this = $(this),
			$parent = $this.parent();

			if ( $parent.hasClass('expanded') ) {
				$parent.removeClass('expanded');
			} else {
				$parent.addClass('expanded');
			}
		});


		$search = $('.js-search');
		$searchHandle = $('.js-search-handle')
		.on('click touchstart', toggleSearch);


		$('.js-search-expand').on('focus', function() {
			var $this = $(this);
			
			$this.parents('.js-search-expand-target').addClass('expanded');
		}).blur(function() {
			var $this = $(this);
			if ( ! $this.val().length ) {
				$this.parents('.js-search-expand-target').removeClass('expanded');
			}
		});
	}
	init();
})(jQuery);


/*
 *   Main
 */

(function($) {

	const $body = $('body');
	var $videoContainer = false;

	const wrappers = document.querySelectorAll(".wp-block-bacardi-slide");

	function calculateSnapPoints(wrapper) {
		let snapPoints = [0];

		fixed.forEach((panel) => {
			console.log(panel.offsetLeft, panel.offsetWidth, wrapper.scrollWidth);
			snapPoints.push( ( ( panel.offsetLeft + (panel.offsetWidth * 0.1) ) / (wrapper.scrollWidth - window.innerWidth) ) );
		});

		snapPoints.push(1);

		console.log(snapPoints);

		scrollTweenTriggerOptions['snap'] = {
			snapTo: snapPoints,
			duration: 0.1,
			delay: 0.1,
			ease: "power1.inOut"
		};

		if ( typeof scrollTween !== 'undefined' ) {
			scrollTween.invalidate();
			scrollTween.restart();
		}
	}

	function resizeBackgrounds() {
		$('.wp-block-bacardi-background.fixed').each(function(index) {
			var $this = $(this),
			$start = $($this.data('start')),
			$end = $($this.data('end')),
			shift = $this.data('shift'),
			left = 0,
			width = 0,
			dist;

			for(let i = $start.index(); i < ($end.index() + 1); i++) {
				width += $('.wp-block-bacardi-panel').eq(i).outerWidth();
			}

			if (shift == 'half') {
				dist = ($start.outerWidth()/2);
				left = left + dist;
				width = width - dist;
			}

			$this.find('.background-color').css({
				left: 0,
				width: width
			});
		});
	}

	function checkScreenSize() {

		if ( typeof scrollTween !== 'undefined' ) {
			scrollTween.invalidate();
			scrollTween.restart();
		}

		if ( typeof backgroundTween !== 'undefined' ) {
			backgroundTween.invalidate();
			backgroundTween.restart();
		}

		if ( typeof siteTitleTween !== 'undefined' ) {
			siteTitleTween.invalidate();
			siteTitleTween.restart();
		}

		resizeBackgrounds();
	}

	function insertBackgroundVideo(videoURL, $videoContainer) {
		var $videoWrapper = '<iframe src="//' + videoURL + '?background=1&wmode=transparent" width="100%" height="100%" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>';
		$videoContainer.html( $videoWrapper );
	}

	function selectBackgroundVideo($videoContainer) {
		insertBackgroundVideo($videoContainer.data('video-desktop'), $videoContainer);
	}

	wrappers.forEach((wrapper) => {
		const panels = gsap.utils.toArray(".wp-block-bacardi-slide .acf-innerblocks-container > .wp-block-bacardi-panel");
		const fixed = gsap.utils.toArray(".wp-block-bacardi-slide .acf-innerblocks-container > .wp-block-bacardi-panel.wp-block-bacardi-fixed");

		let scrollTweenTriggerOptions = {
			trigger: ".wp-block-bacardi-slide",
			start:"top: 0%",
			pin: true,
			scrub: 1,
			end: () => "+=" + (wrapper.scrollWidth - innerWidth),
			invalidateOnRefresh: true
		}

		let panelsSection = document.querySelector("#panels"),
		panelsContainer = document.querySelector("#panels-container");
	

		/* Unhide panels for calculation */

		$('.wp-block-bacardi-panel').show();


		/* Initiate Lenis */

		const lenis = new Lenis({
			duration: 1.2,
			easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
			orientation: 'horizontal',
			gestureOrientation: 'horizontal',
			smoothWheel: false
		});

	    lenis.on('scroll', (e) => {});

		function raf(time) {
			lenis.raf(time);
			requestAnimationFrame(raf);
		}

		requestAnimationFrame(raf);

		gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

		let mm = gsap.matchMedia();

		lenis.on("scroll", () => {
			ScrollTrigger.update();
		});

		/* Add GSAP Timelines */

		if ( wrapper ) {

			/* MatchMedia: Mobile/Tablet Size */

			mm.add("(max-width: 959px)", () => {
				const decorations = gsap.utils.toArray(".wp-block-bacardi-slide .acf-innerblocks-container > .wp-block-bacardi-panel.wp-block-bacardi-decoration .decoration-image, .wp-block-bacardi-slide .acf-innerblocks-container > .wp-block-bacardi-panel .wp-block-arch-image .arch-overlay-image img");

				var decorationsDefaultFromOptions = {
					autoAlpha: 0
				};

				var decorationsDefaultToOptions = {
					autoAlpha: 1
				};

				decorations.forEach((decoration, i) => {

					let scrollTriggerOptions = {
						ease: 'none',
						scrollTrigger: {
							trigger: decoration,
							start: "top 50%",
							end: "bottom 20%",
							invalidateOnRefresh: true
						}
					};

					let decorationsElemFromOptions = JSON.parse(decoration.dataset.from);
					let decorationsElemToOptions = JSON.parse(decoration.dataset.to);

					let decorationsFromOptions = {
						...decorationsDefaultFromOptions,
						...decorationsElemFromOptions
					};

					let decorationsToOptions = {
						...decorationsDefaultToOptions,
						...decorationsElemToOptions,
						...scrollTriggerOptions
					};

					let decorationTween = gsap.fromTo(decoration, decorationsFromOptions, decorationsToOptions);
				});

				const background = gsap.utils.toArray('.wp-block-bacardi-background.fade');
				if ( background ) {
					background.forEach(target => {
						let backgroundTween = gsap.fromTo(target, {
							opacity: 0
						},
						{
							opacity: 1,
							scrollTrigger: {
								trigger: target.dataset.start,
								start: "top 90%",
								end: background[0].offsetWidth,
								scrub: true,
								end: "+=400",
								invalidateOnRefresh: true
							}
						});
					});
				}
			});


			/* MatchMedia: Desktop Size */

			mm.add("(min-width: 960px)", () => {

				// $body.addClass('fs-navigation-lock');

				/* If Goals page, calculate snapping settings */

				// if ( $body.hasClass('page-goals') ) {
				// 	calculateSnapPoints(wrapper);
				// 	window.addEventListener('resize', calculateSnapPoints);
				// }


				/* 
				 * Initiate Tween with ScrollTrigger
				 * This is the main timeline for all horizontal scrolling actions.
				 */

				let scrollTween = gsap.to(panels, {
					x: () => -1 * (wrapper.scrollWidth - innerWidth),
					ease: "none", // <-- IMPORTANT!
					scrollTrigger: scrollTweenTriggerOptions
				});


				/* Fading Backgrounds */

				const background = gsap.utils.toArray('.wp-block-bacardi-background.fade');
				if ( background ) {
					background.forEach(target => {
						let backgroundTween = gsap.fromTo(target, 
							{opacity: 0},
							{
								opacity: 1,
								scrollTrigger: {
									containerAnimation: scrollTween,
									trigger: target.dataset.start,
									start: "left 50%",
									end: background[0].offsetWidth,
									scrub: true,
									end: "+=800",
									invalidateOnRefresh: true
								}
							}
						);
					});
				}


				/* Changing Header colors on different backgrounds */

				const body = document.querySelector('body');

				function addDarkClassForSiteTitle() {
					body.classList.remove('text-light-site-title');
					body.classList.add('text-dark-site-title');
				}
				function addLightClassForSiteTitle() {
					body.classList.remove('text-dark-site-title');
					body.classList.add('text-light-site-title');
				}

				function addDarkClassForPageTitle() {
					body.classList.remove('text-light-page-title');
					body.classList.add('text-dark-page-title');
				}
				function addLightClassForPageTitle() {
					body.classList.remove('text-dark-page-title');
					body.classList.add('text-light-page-title');
				}

				function addDarkClassForSiteLogo() {
					body.classList.remove('text-light-logo');
					body.classList.add('text-dark-logo');
				}
				function addLightClassForSiteLogo() {
					body.classList.remove('text-dark-logo');
					body.classList.add('text-light-logo');
				}

				const darken = gsap.utils.toArray('.wp-block-bacardi-slide .wp-block-bacardi-panel.text-dark');

				let onLeaveBackCallbackSiteTitle = null;
				let onLeaveBackCallbackPageTitle = null;
				let onLeaveBackCallbackSiteLogo  = null;

				if ( darken.length ) {
					darken.forEach(target => {
						if ( target === document.querySelector('.wp-block-bacardi-slide .wp-block-bacardi-panel.text-dark') ) {
							console.log("First One");
							console.log( target.innerHTML );
							onLeaveBackCallbackSiteTitle = addLightClassForSiteTitle;
							onLeaveBackCallbackPageTitle = addLightClassForPageTitle;
							onLeaveBackCallbackSiteLogo  = addLightClassForSiteLogo;
						} else {
							onLeaveBackCallbackSiteTitle = addDarkClassForSiteTitle;
							onLeaveBackCallbackPageTitle = addDarkClassForPageTitle;
							onLeaveBackCallbackSiteLogo  = addDarkClassForSiteLogo;
						}

						let darkenSiteTitleTween = gsap.from(target, {
							scrollTrigger: {
								containerAnimation: scrollTween,
								trigger: target,
								start: "left 95%",
								end: "left 95%",
								overwrite: 'all',
								immediateRender: false,
								scrub: true,
								onEnter: addDarkClassForSiteTitle,
								onLeaveBack: onLeaveBackCallbackSiteTitle,
								invalidateOnRefresh: true
							}
						});

						let darkenPageTitleTween = gsap.from(target, {
							scrollTrigger: {
								containerAnimation: scrollTween,
								trigger: target,
								start: "left 55%",
								end: "left 55%",
								overwrite: 'all',
								immediateRender: false,
								scrub: true,
								onEnter: addDarkClassForPageTitle,
								onLeaveBack: onLeaveBackCallbackPageTitle,
								invalidateOnRefresh: true
							}
						});

						let darkenSiteLogoTween = gsap.from(target, {
							scrollTrigger: {
								containerAnimation: scrollTween,
								trigger: target,
								start: "left 25%",
								end: "left 25%",
								overwrite: 'all',
								immediateRender: false,
								scrub: true,
								onEnter: addDarkClassForSiteLogo,
								onLeaveBack: onLeaveBackCallbackSiteLogo,
								invalidateOnRefresh: true
							}
						});
					});
				}

				// const lighten = gsap.utils.toArray('.wp-block-bacardi-slide .wp-block-bacardi-panel.text-light');
				// if ( lighten.length ) {
				// 	lighten.forEach(target => {
				// 		let lightenSiteTitleTween = gsap.from(target, {
				// 			scrollTrigger: {
				// 				containerAnimation: scrollTween,
				// 				trigger: target,
				// 				start: "right 95%",
				// 				end: "right 95%",
				// 				overwrite: 'auto',
				// 				immediateRender: false,
				// 				scrub: true,
				// 				onEnter: addLightClassForSiteTitle,
				// 				onLeaveBack: addLightClassForSiteTitle,
				// 				invalidateOnRefresh: true
				// 			}
				// 		});

				// 		let lightenPageTitleTween = gsap.from(target, {
				// 			scrollTrigger: {
				// 				containerAnimation: scrollTween,
				// 				trigger: target,
				// 				start: "right 55%",
				// 				end: "right 55%",
				// 				overwrite: 'auto',
				// 				immediateRender: false,
				// 				scrub: true,
				// 				onEnter: addLightClassForPageTitle,
				// 				onLeaveBack: addLightClassForPageTitle,
				// 				invalidateOnRefresh: true
				// 			}
				// 		});

				// 		let lightenSiteLogoTween = gsap.from(target, {
				// 			scrollTrigger: {
				// 				containerAnimation: scrollTween,
				// 				trigger: target,
				// 				start: "right 25%",
				// 				end: "right 25%",
				// 				overwrite: 'auto',
				// 				immediateRender: false,
				// 				scrub: true,
				// 				onEnter: addLightClassForSiteLogo,
				// 				onLeaveBack: addLightClassForSiteLogo,
				// 				invalidateOnRefresh: true
				// 			}
				// 		});
				// 	});
				// }

				const lightenArticles = gsap.utils.toArray('.wp-block-bacardi-panel.wp-block-bacardi-articles');
				if ( lightenArticles.length ) {
					lightenArticles.forEach(target => {
						let lightenSiteTitleTween = gsap.from(target, {
							scrollTrigger: {
								trigger: target,
								start: "top 10%",
								overwrite: 'all',
								scrub: true,
								onEnter: addLightClassForSiteTitle,
								onLeaveBack: addDarkClassForSiteTitle,
								invalidateOnRefresh: true
							}
						});

						let lightenPageTitleTween = gsap.from(target, {
							scrollTrigger: {
								trigger: target,
								start: "top 10%",
								overwrite: 'all',
								scrub: true,
								onEnter: addLightClassForPageTitle,
								onLeaveBack: addDarkClassForPageTitle,
								invalidateOnRefresh: true
							}
						});

						let lightenSiteLogoTween = gsap.from(target, {
							scrollTrigger: {
								trigger: target,
								start: "top 10%",
								overwrite: 'all',
								scrub: true,
								onEnter: addLightClassForSiteLogo,
								onLeaveBack: addDarkClassForSiteLogo,
								invalidateOnRefresh: true
							}
						});
					});
				}

				// const darkenArticles = gsap.utils.toArray('.wp-block-bacardi-panel.wp-block-bacardi-articles');
				// if ( darkenArticles.length ) {
				// 	darkenArticles.forEach(target => {
				// 		let darkenSiteTitleTween = gsap.from(target, {
				// 			scrollTrigger: {
				// 				trigger: target,
				// 				start: "top 90%",
				// 				end: "top 90%",
				// 				overwrite: 'auto',
				// 				immediateRender: false,
				// 				scrub: true,
				// 				onEnter: addDarkClassForSiteTitle,
				// 				onLeaveBack: addDarkClassForSiteTitle,
				// 				invalidateOnRefresh: true
				// 			}
				// 		});

				// 		let darkenPageTitleTween = gsap.from(target, {
				// 			scrollTrigger: {
				// 				trigger: target,
				// 				start: "top 90%",
				// 				end: "top 90%",
				// 				overwrite: 'auto',
				// 				immediateRender: false,
				// 				scrub: true,
				// 				onEnter: addDarkClassForPageTitle,
				// 				onLeaveBack: addDarkClassForPageTitle,
				// 				invalidateOnRefresh: true
				// 			}
				// 		});

				// 		let darkenSiteLogoTween = gsap.from(target, {
				// 			scrollTrigger: {
				// 				trigger: target,
				// 				start: "top 90%",
				// 				end: "top 90%",
				// 				overwrite: 'auto',
				// 				immediateRender: false,
				// 				scrub: true,
				// 				onEnter: addDarkClassForSiteLogo,
				// 				onLeaveBack: addDarkClassForSiteLogo,
				// 				invalidateOnRefresh: true
				// 			}
				// 		});
				// 	});
				// }


				/* Articles Blocks - Opacity */

				const articlesBlocks = gsap.utils.toArray('.wp-block-bacardi-panel.wp-block-bacardi-articles');
				if ( articlesBlocks.length ) {
					articlesBlocks.forEach(target => {
						let articlesOpacityClassOnTween = gsap.to(target, {
							scrollTrigger: {
								containerAnimation: scrollTween,
								trigger: target,
								start: "left 75%",
								scrub: true,
								toggleClass: 'visible',
								invalidateOnRefresh: true
							}
						});
					});
				}

				/* Flyout Bump at Bottom */

				// const marqueeBlocks = gsap.utils.toArray('.wp-block-bacardi-panel.infinite-loop-panel');
				// if ( marqueeBlocks.length ) {
					let marqueeVisibilityClassOnTween = gsap.to(".flyout-navigation", {
						scrollTrigger: {
							trigger: ".wp-block-bacardi-panel.infinite-loop-panel",
							start: "top bottom",
							scrub: true,
							toggleClass: {
								targets: ".flyout-navigation",
								className: "expanded"
							},
							invalidateOnRefresh: true
						}
					});
				// }


				/* Goals (Fixed) Blocks */

				const fixedBlocks = gsap.utils.toArray('.wp-block-bacardi-fixed-blocks');
				var count = 1;
				
				if ( fixedBlocks ) {

					var firstItem = false;

					fixedBlocks.forEach(target => {

						// Show Fixed Blocks - Opacity

						const opacityTL = gsap.timeline({
							scrollTrigger: {
								// containerAnimation: scrollTween,
								trigger: target.closest('.wp-block-bacardi-fixed'),
								start: "top 75%",
								end: () => "+=100",
								scrub: true,
								invalidateOnRefresh: true
							}
						});

						opacityTL
							.fromTo(target, 
							{ 
								autoAlpha: 0,
								duration: 0.25,
								ease: "ease" 
							},
							{ 
								autoAlpha: 1,
								duration: 0.25,
								ease: "ease" 
							});


						// Show Attached Items - Class

						let fixedOpacityClassOnTween = gsap.to(target, {
							scrollTrigger: {
								trigger: target.closest('.wp-block-bacardi-fixed'),
								start: "top 75%",
								scrub: true,
								toggleClass: 'visible',
								invalidateOnRefresh: true
							}
						});


						// Count Attached Figures - OnEnter

						function countUpNumbers() {
							const els = document.querySelectorAll( '.js-countup' );
							els.forEach((el) => {
								counterUp( el, {
									duration: 1000,
									delay: 10,
								});
							});
						}

						let countUpTween = gsap.to(target, {
							scrollTrigger: {
								trigger: target.closest('.wp-block-bacardi-fixed'),
								start: "top 75%",
								scrub: true,
								onEnter: countUpNumbers,
								invalidateOnRefresh: true
							}
						});


						// // Pin Fixed Block Content

						// let fixedMarginTween = gsap.to(target, {
						// 	ease: "none",
						// 	x: () => window.innerWidth * 1.2, // counter-animate the content of the section
						// 	scrollTrigger: {
						// 		trigger: target.closest('.wp-block-bacardi-fixed'),
						// 		start: "top 75%",
						// 		scrub: true,
						// 		end: () => "+=" + window.innerWidth * 1.2,
						// 		invalidateOnRefresh: true
						// 	}
						// });
						

						// Show Static Goals Content Upon First Fixed Block
						
						// if ( firstItem === false ) {
						// 	const goalsContent = document.querySelector('.js-goals-content');
						// 	const title = document.querySelector('.page-title');

						// 	function addGoalsClass() {
						// 		goalsContent.classList.add('visible');
						// 		// title.classList.add('hidden');
						// 	}

						// 	function removeGoalsClass() {
						// 		goalsContent.classList.remove('visible');
						// 		// title.classList.remove('hidden');
						// 	}

						// 	let goalsOpacityTween = gsap.to(goalsContent, {
						// 		scrollTrigger: {
						// 			// containerAnimation: scrollTween,
						// 			trigger: target.closest('.wp-block-bacardi-fixed'),
						// 			start: "top 75%",
						// 			scrub: true,
						// 			onEnter: addGoalsClass,
						// 			onLeaveBack: removeGoalsClass,
						// 			invalidateOnRefresh: true
						// 		}
						// 	});

						// 	firstItem = true;
						// }

						count++;
					});
				}
				
				/* Decoration Blocks */

				const decorations = gsap.utils.toArray(".wp-block-bacardi-slide .acf-innerblocks-container > .wp-block-bacardi-panel.wp-block-bacardi-decoration .decoration-image, .wp-block-bacardi-slide .acf-innerblocks-container > .wp-block-bacardi-panel .wp-block-arch-image .arch-overlay-image img");

				var decorationsDefaultFromOptions = {
					autoAlpha: 0
				};

				var decorationsDefaultToOptions = {
					autoAlpha: 1
				};

				decorations.forEach((decoration, i) => {

					let scrollTriggerOptions = {
						ease: 'none',
						scrollTrigger: {
							containerAnimation: scrollTween,
							trigger: decoration,
							start: "left 80%",
							end: "left 20%",
							invalidateOnRefresh: true
						}
					}

					let decorationsElemFromOptions = JSON.parse(decoration.dataset.from);
					let decorationsElemToOptions = JSON.parse(decoration.dataset.to);

					let decorationsFromOptions = {
						...decorationsDefaultFromOptions,
						...decorationsElemFromOptions
					};

					let decorationsToOptions = {
						...decorationsDefaultToOptions,
						...decorationsElemToOptions,
						...scrollTriggerOptions
					}

					let decorationTween = gsap.fromTo(decoration, decorationsFromOptions, decorationsToOptions);
				});


				/* Progress Bar */

				gsap.to('progress', {
					value: 100,
					ease: 'sine.out',
					scrollTrigger: {
						scrub: 0.3,
						end: () => "+=" + (wrapper.scrollWidth - innerWidth)
					}
				});

				// checkScreenSize();
			});

		
			/* MatchMedia: Desktop Size where Header interferes with UI */
		
			// mm.add("(min-width: 960px) and (max-width: 1825px)", () => {

				// let siteTitleTween = gsap.to('.site-title', {
				// 	translateX: '-130px',
				// 	ease: "none", 
				// 	scrollTrigger: {
				// 		trigger: '.infinite-loop-panel',
				// 		start: wrapper.scrollWidth - innerWidth - 135,
				// 		scrub: true
				// 	}
				// });

				// let goalsContentTween = gsap.to('.js-goals-content', {
				// 	translateX: '-130px',
				// 	ease: "none", 
				// 	scrollTrigger: {
				// 		trigger: '.infinite-loop-panel',
				// 		start: wrapper.scrollWidth - innerWidth - 135,
				// 		scrub: true
				// 	}
				// });

				// let goalsSectionTween = gsap.to('.wp-block-bacardi-panel.wp-block-bacardi-fixed.goals-sources .acf-innerblocks-container', {
				// 	translateX: '-130px',
				// 	ease: "none", 
				// 	scrollTrigger: {
				// 		trigger: '.infinite-loop-panel',
				// 		start: wrapper.scrollWidth - innerWidth - 135,
				// 		scrub: true
				// 	}
				// });

				// let goalsImagesTween = gsap.to('.wp-block-bacardi-panel.wp-block-bacardi-fixed.goals-sources .fixed-images', {
				// 	translateX: '-130px',
				// 	ease: "none", 
				// 	scrollTrigger: {
				// 		trigger: '.infinite-loop-panel',
				// 		start: wrapper.scrollWidth - innerWidth - 135,
				// 		scrub: true
				// 	}
				// });

				// return () => { // optional
				// 	// custom cleanup code here (runs when it STOPS matching)
				// 	};
			// });

		}
	});

	// $('.flyout-navigation-section-handle').on('click', function(e) {
	// 	var $this = $(this);

	// 	e.preventDefault();
	// 	e.stopPropagation();

	// 	if ( $this.parents('.flyout-navigation').hasClass('left') && $('.flyout-navigation.right') ) {
	// 		$('.flyout-navigation.right').removeClass('is-open').find('.flyout-navigation-section-handle').parent().removeClass('is-selected');
	// 	}

	// 	if ( $this.parents('.flyout-navigation').hasClass('right') && $('.flyout-navigation.left') ) {
	// 		$('.flyout-navigation.left').removeClass('is-open').find('.flyout-navigation-section-handle').parent().removeClass('is-selected');
	// 	}

	// 	$('.js-flyout-video').empty();

	// 	$this.parent().siblings().removeClass('is-selected');

	// 	$('.header .flyout-navigation-section-title').remove();

	// 	$('.header .page-title').after($this.parent().find('.flyout-navigation-section-title').clone());

	// 	$this.parent().addClass('is-selected').parents('.flyout-navigation').addClass('is-open');

	// 	var $which = $this.data('name');

	// 	$body.addClass('fs-navigation-lock').addClass('flyout-open').removeClass('flyout-good-choices').removeClass('flyout-good-footprint').removeClass('flyout-good-futures').removeClass('flyout-good-sources').addClass('flyout-'+$which);

	// 	$videoContainer = $this.parent().find('.js-flyout-video');

	// 	$('body').on('click', function(event) {
	// 		if (!$(event.target).closest($('.flyout-navigation')).length) {
	// 			$('.flyout-navigation-section-handle').parent().removeClass('is-selected');
	// 			$('.flyout-navigation').removeClass('is-open');
	// 			$('.header .flyout-navigation-section-title').remove();
	// 			$body.off('click', '.flyout-navigation').removeClass('flyout-open').removeClass('flyout-good-choices').removeClass('flyout-good-footprint').removeClass('flyout-good-futures').removeClass('flyout-good-sources');
	// 			if ( ! $body.hasClass('menu-open') ) {
	// 				$body.removeClass('fs-navigation-lock');
	// 			}
	// 		}
	// 	});

	// 	$this.parent().find('.js-flyout-close').on('click', function(event) { console.log("clicked!");
	// 		$('.flyout-navigation-section-handle').parent().removeClass('is-selected');
	// 		$('.flyout-navigation').removeClass('is-open');
	// 		$('.header .flyout-navigation-section-title').remove();
	// 		$body.off('click', '.flyout-navigation').removeClass('flyout-open').removeClass('flyout-good-choices').removeClass('flyout-good-footprint').removeClass('flyout-good-futures').removeClass('flyout-good-sources');
	// 		if ( ! $body.hasClass('menu-open') ) {
	// 			$body.removeClass('fs-navigation-lock');
	// 		}
	// 	});

	// 	if ( $videoContainer.length ) {
	// 		selectBackgroundVideo($videoContainer);
	// 	}
	// });

	window.onload = (event) => {
		$body.addClass('page-loaded');
		console.log('loaded');
	};

	// var $articles = $('.js-articles'),
	// $handles = $articles.find('.js-article-handle'),
	// $bodies = $articles.find('.js-article-body'),
	// $images = $articles.find('.js-post-images'),
	// $scrollIcon = $('#scroll-icon');

	// if ( ( ! $body.hasClass('page-full-report')) && $handles.length > 1 ) {

	// 	$handles.on('click', function(){
	// 		var $this = $(this),
	// 		$target = $($this.data('target'));
	// 				// $post_images = $images.filter('[data-post="'+ $this.data('target') +'"]');

	// 		$handles.removeClass('viewing');
	// 		$this.addClass('viewing');

	// 		$bodies.removeClass('show');
	// 		$target.addClass('show');

	// 			// $images.removeClass('show');
	// 			// $post_images.addClass('show');
	// 	});

	// 	$handles.eq(0).trigger('click');
	// } else {
	// 	$handles.eq(0).addClass('viewing');
	// 	$bodies.eq(0).addClass('show');
	// 		// $images.eq(0).addClass('show');
	// }

	// $('.js-article-select').on('change', function(e){
	// 	var $target = $( "[data-target='" + $(this).val() + "'']" );
	// 	$target.trigger('click');
	// });

	// $bodies.first().on('scroll', function(e) {
	// 	$scrollIcon.fadeOut();
	// 	$bodies.first().off('scroll');
	// });

	/* Waves */

	const wavifyOptionsDesktop = {
		height: 30,
		bones: 5,
		amplitude: 30,
		speed: .25
	};

		// wavifyOptionsMobile = {
		// 	height: 20,
		// 	bones: 3,
		// 	amplitude: 20,
		// 	speed: .45
		// };

	const $waveContainer = $('.js-wavify');
	var waveAnimationInit = false;

	$waveContainer.append('<svg width="100%" height="100%" version="1.1" xmlns="http://www.w3.org/2000/svg" class="wave"><title>Wave</title><defs></defs><path id="wave-border" class="wave-border" d=""/></svg>');

	const $waveObject = $('#wave-border');

	function startWavify(e, state) {
		var waveOptions = $.extend({}, wavifyOptionsDesktop),
		waveAnimation;

			// if ( state.minWidth >= 576 ) {
				// footerOptions = $.extend({}, wavifyOptionsDesktop);

			// } else {
				// footerOptions = $.extend({}, wavifyOptionsMobile);
				// headerOptions = $.extend({}, wavifyOptionsMobile);
			// }

			// footerOptions['color'] = '#3d5249';
		waveOptions['color'] = '#ffffff';

			// if ( $footerObject.length ) {
			// 	if ( footerAnimationInit ) {
			// 		footerAnimation.reboot(footerOptions);
			// 	} else {
			// 		footerAnimation = $footerObject.wavify(footerOptions);
			// 		footerAnimationInit = true;
			// 	}
			// }

		if ( $waveObject.length ) {
			if ( waveAnimationInit ) {
				waveAnimation.reboot(waveOptions);
			} else {
				waveAnimation = $waveObject.wavify(waveOptions);
				waveAnimationInit = true;
				console.log("waving");
			}
		}
	}

	if ( ! $('body').hasClass('page-template-page-full') ) {
		startWavify();
	} else {
		$('.wave-border').attr('d', 'M0,288L48,266.7C96,245,192,203,288,181.3C384,160,480,160,576,186.7C672,213,768,267,864,250.7C960,235,1056,149,1152,133.3C1248,117,1344,171,1392,197.3L1440,224L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z').parents('svg').attr('viewbox', '0 0 1440 100').attr('preserveAspectRatio','none');
	}

		// Intercept click for menu items that don't go anywhere
	$('.menu-main a[href="#"]').click(function(e) {
		e.preventDefault();
	});

	// if ( $('.flyout-navigation').length ) {
	// 	$('.js-element-link').click(function(e) {
	// 		e.preventDefault();
	// 		e.stopPropagation();

	// 		var $this = $(this),
	// 		$target = $($this.data('element'));

	// 		$target.trigger('click');
	// 	});
	// }

	if ( $('.js-block-popup').length ) {

		$('.js-block-popup').each(function() {

			var $this = $(this),
			$handle = $($this.data('handle') + ' > a'),
			$close = $this.find('.js-popup-close');

			$handle.click(function(e) {
				e.preventDefault();
				e.stopPropagation();

				$this.addClass('visible');
			});

			$close.click(function(e) {
				e.preventDefault();
				e.stopPropagation();

				$this.removeClass('visible');
			});

			$this.on('click', function(event) {
				if (!$(event.target).closest($('.js-popup-content')).length) {
					$this.removeClass('visible');
				}
			})
		});
	};

	$videoContainer = $('.js-page-header-video');

	$(window).resize(checkScreenSize);

	checkScreenSize();
	
	console.log('adding');

	if ( $videoContainer.length ) {
		selectBackgroundVideo($videoContainer);

	}

	window.addEventListener('load', function () {
	  $body.removeClass('fs-navigation-lock');
	});	

	$('.wp-social-link-twitter > a').html('<svg width="24" height="24" viewBox="0 0 24 24" version="1.1"><path d="M14.1173 9.62177L20.4459 2H18.9463L13.4511 8.61788L9.06215 2H4L10.637 12.0074L4 20H5.49977L11.3028 13.0113L15.9379 20H21L14.1169 9.62177H14.1173ZM12.0632 12.0956L11.3907 11.0991L6.04016 3.16971H8.34371L12.6617 9.56895L13.3341 10.5655L18.947 18.8835H16.6434L12.0632 12.096V12.0956Z" /></svg>');

// });

})(jQuery);
